module.exports = __webpack_public_path__ + "media/s6Model4.a14b6c6d.mp4";